// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"44":"96e8ea45","96":"676d9e0d","293":"b9d94dc3","358":"b58c91b8","389":"4716904f","404":"2b4a1f2a","570":"739b642e","589":"540e23c9","627":"819fc156","641":"35f9dbc2"}[chunkId] + ".chunk.js";
};